import { createContext } from 'react';

const HeaderContext = createContext({
  activeMegaMenu: null,
  isSearchActive: false,
  toggleMegaMenu: () => {},
  closeMegaMenu: () => {},
  setSearchActive: () => {},
  setSuggestionsActive: () => {},

  activeFlyout: null,
  setActiveFlyout: () => {},
  toggleFlyout: () => {},
});

export default HeaderContext;
